import { makeStyles, tokens } from '@fluentui/react-components';

export const useStarRatingStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '1px',
  },
  starWrapper: {
    position: 'relative',
    display: 'inline-flex',
  },
  filledStar: {
    color: tokens.colorPaletteMarigoldForeground2,
  },
  emptyStar: {
    color: tokens.colorNeutralForeground4,
  },
  halfStarOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    overflow: 'hidden',
    width: '50%',
    color: tokens.colorPaletteMarigoldForeground2,
  },
});
